/**
 * Set Cookie
 *
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {number} daysToLive - The number of days to live
 * @param {string} path - The path of the cookie
 */
export function setCookie(name, value, daysToLive = 30, path = '/') {
  let cookies = [
    [name, value],
    ['path', path],
  ];
  if (daysToLive) cookies.push(['max-age', daysToLive * 24 * 60 * 60]);
  document.cookie = cookies.map((cookie) => cookie.join('=')).join(';');
}

/**
 * Get Cookie
 *
 * @param {string} name - The name of the cookie
 * @returns {string} The value of the cookie
 */
export function getCookie(name) {
  let data = null;
  document.cookie.split(';').some((e) => {
    let cookie = e.split('=');
    if (cookie[0].replace(' ', '') === name) {
      data = cookie[1];
      return true;
    }
  });
  return data;
}
